import { useEditor } from '../../hooks/useEditor';

export const FooterContent = () => {
  const { userSession, userLogout } = useEditor();

  return (
    <>
      <span>
        ©{new Date().getFullYear()} PatchKit Editor
        <span
          className="editorContainer"
          style={{
            margin: '0 5px',
            color: 'var(--text-color-secondary)',
          }}
        >
          v1.0.0
        </span>
        <span
          className="editorContainer"
          style={{
            color: 'var(--text-color-secondary)',
          }}
        >
          Beta
        </span>
      </span>
      <span>
        {userSession.email || ''}
        {userSession.email && (
          <a style={{ padding: '0 5px' }} href="#" onClick={userLogout}>
            Log out of Editor and Panel
          </a>
        )}
      </span>
    </>
  );
};
